export enum EntityType {
  CONTRACT = "contract",
  OFFER = "offer",
}
